/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeQuotaSupplementaireDto } from '../models/demande-quota-supplementaire-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des demandes de quotas supplémentaires pour les personnes morales
 */
@Injectable({
  providedIn: 'root',
})
export class DemandesQuotasSupplementairesPersonneMoraleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleGetList
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleGetListPath = '/api/demandes-quotas-supplementaires-personne-morale/list';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGetList(params?: {
  }): Observable<Array<DemandeQuotaSupplementaireDto>> {

    return this.demandesQuotasSupplementairesPersonneMoraleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DemandeQuotaSupplementaireDto>>) => r.body as Array<DemandeQuotaSupplementaireDto>)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleLoadList
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleLoadListPath = '/api/demandes-quotas-supplementaires-personne-morale/load-list';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoraleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoraleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandesQuotasSupplementairesPersonneMoraleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleLoadList2
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleLoadList2Path = '/api/demandes-quotas-supplementaires-personne-morale/personne/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des demandes de quotas supplémentaires de la personne morale spécifiée pour l'année en cours (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoraleLoadList2$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleLoadList2Path, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de quotas supplémentaires de la personne morale spécifiée pour l'année en cours (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoraleLoadList2(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandesQuotasSupplementairesPersonneMoraleLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleGet
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleGetPath = '/api/demandes-quotas-supplementaires-personne-morale/personne/{personneMoraleId}/{id}';

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGet$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleGetPath, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGet(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonneMoraleGet$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoralePutForPersonne
   */
  static readonly DemandesQuotasSupplementairesPersonneMoralePutForPersonnePath = '/api/demandes-quotas-supplementaires-personne-morale/personne/{personneMoraleId}/{id}';

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoralePutForPersonne()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePutForPersonne$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoralePutForPersonnePath, 'put');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoralePutForPersonne$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePutForPersonne(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonneMoralePutForPersonne$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleGet2
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleGet2Path = '/api/demandes-quotas-supplementaires-personne-morale/{id}';

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGet2$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Renvoie la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleGet2(params: {

    /**
     * Identifiant de la demande de quota supplémentaire
     */
    id: number;
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonneMoraleGet2$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoralePut
   */
  static readonly DemandesQuotasSupplementairesPersonneMoralePutPath = '/api/demandes-quotas-supplementaires-personne-morale/{id}';

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoralePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePut$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoralePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Met à jour la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoralePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePut(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à mettre à jour
     */
    id: number;

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonneMoralePut$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoraleDelete
   */
  static readonly DemandesQuotasSupplementairesPersonneMoraleDeletePath = '/api/demandes-quotas-supplementaires-personne-morale/{id}';

  /**
   * Supprime la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoraleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleDelete$Response(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoraleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoraleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandesQuotasSupplementairesPersonneMoraleDelete(params: {

    /**
     * Identifiant de la demande de quota supplémentaire à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.demandesQuotasSupplementairesPersonneMoraleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation demandesQuotasSupplementairesPersonneMoralePost
   */
  static readonly DemandesQuotasSupplementairesPersonneMoralePostPath = '/api/demandes-quotas-supplementaires-personne-morale';

  /**
   * Crée la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandesQuotasSupplementairesPersonneMoralePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePost$Response(params: {

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<StrictHttpResponse<DemandeQuotaSupplementaireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesQuotasSupplementairesPersonneMoraleService.DemandesQuotasSupplementairesPersonneMoralePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeQuotaSupplementaireDto>;
      })
    );
  }

  /**
   * Crée la demande de quota supplémentaire spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandesQuotasSupplementairesPersonneMoralePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandesQuotasSupplementairesPersonneMoralePost(params: {

    /**
     * Demande de quota supplémentaire
     */
    body: DemandeQuotaSupplementaireDto
  }): Observable<DemandeQuotaSupplementaireDto> {

    return this.demandesQuotasSupplementairesPersonneMoralePost$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeQuotaSupplementaireDto>) => r.body as DemandeQuotaSupplementaireDto)
    );
  }

}
